export enum TradingCharacteristicEnum {
  RMKT = 'RMKT',
  RMQI = 'RMQI',
  MSGM = 'MSGM',
  MLTF = 'MLTF',
}
